import React, {useEffect, useState} from "react";
import { Route, Routes, useNavigate } from 'react-router-dom';
import OrderCreationScreen from "../OrderCreationScreen/OrderCreationScreen.jsx";
import FilterPopup from "../FilterPopup/FilterPopup.jsx"
import FilterPopup_old from "../FilterPopup/FilterPopup_old.jsx"
import RedirectToPhone from "../Call/Call.jsx"
import RedirectToMail from "../Mail/Mail"
import RedirectTelegramScreen from "../RedirectTelegram/RedirectTelegram.jsx"
import AddCard from "../AddCard/AddCard.jsx"
import * as gruzovikiApi from "../../utils/api.js"
import FilterPopupNew from "../FilterPopup/FilterPopupNew";

function App() {

    return (
        <div>
            <Routes>
                <Route path="/create-order" element={<OrderCreationScreen />} />
                <Route path="/search" element={<FilterPopup_old />} />
                <Route path="/filter" element={<FilterPopup />} />
                <Route path="/filterNew" element={<FilterPopupNew />} />
                <Route path="/call" element={<RedirectToPhone />}  />
                <Route path="/mail" element={<RedirectToMail />}  />
                <Route path="/help" element={<RedirectTelegramScreen />}  />
                <Route path="/addCard" element={<AddCard />}  />
                {/*<Route path="/test" element={<ConnectWallet />}  />*/}
            </Routes>
        </div>


    );
}

export default App